export type Color = string;

export type TileType =
  | 'normal'
  | 'locked'
  | 'penalty'
  | 'rotateL'
  | 'rotateR'
  | 'mirrorH'
  | 'mirrorV'
  | 'inversion'
  | 'chaos'
  | 'flipping';

export const SPECIAL_ONE_SHOT: readonly TileType[] = [
  'rotateL',
  'rotateR',
  'mirrorH',
  'mirrorV',
  'inversion',
  'chaos',
];

export interface Cell {
  readonly color: Color;
  readonly tile: TileType;
  /** For tile === 'flipping' only: the alternate face's colour. */
  readonly altColor?: Color;
}

export interface Coord {
  readonly x: number;
  readonly y: number;
}

export interface Board {
  readonly size: number;
  readonly cells: readonly (readonly Cell[])[];
  readonly start: Coord;
  readonly end: Coord;
  readonly palette: readonly Color[];
  readonly level: number;
}

export type GameStatus = 'playing' | 'won' | 'lost';

export interface GameState {
  readonly board: Board;
  readonly movesUsed: number;
  readonly moveBudget: number;
  readonly status: GameStatus;
  readonly visitedPenalty: ReadonlySet<string>;
  readonly visitedSpecial: ReadonlySet<string>;
}

export type Effect =
  | { readonly type: 'flood'; readonly cells: readonly Coord[]; readonly to: Color }
  | { readonly type: 'penalty'; readonly cells: readonly Coord[]; readonly movesLost: number }
  | { readonly type: 'rotate'; readonly degrees: number }
  | { readonly type: 'mirror'; readonly axis: 'x' | 'y' }
  | {
      readonly type: 'inversion';
      readonly origin: Coord;
      readonly mapping: ReadonlyMap<Color, Color>;
    }
  | {
      readonly type: 'chaos';
      readonly origin: Coord;
      readonly mapping: ReadonlyMap<Color, Color>;
    }
  | { readonly type: 'win' }
  | { readonly type: 'lose' };

export interface MoveResult {
  readonly state: GameState;
  readonly effects: readonly Effect[];
  readonly rejected: boolean;
}

export const coordKey = (c: Coord): string => `${c.x},${c.y}`;
